export default __webpack_public_path__ + "static/media/pokoj-podkrovi.50c657d4.jpeg";